// extracted by mini-css-extract-plugin
export default {"box":"MessageGrid_box__mIqY4","container":"MessageGrid_container__yXANy","btn":"MessageGrid_btn__r0ISn","time":"MessageGrid_time__J6moL"};